import React from "react";
import { useTranslation } from "react-i18next";
import "./TermsHero.css";

const TermsHero = () => {
  const { t } = useTranslation();

  return (
    <section className="termsHero">
      <div className="termsHero-inner">
        <h1>{t("sections.terms.heroTitle")}</h1>
        <p>{t("sections.terms.heroDesc")}</p>
        <span>{t("sections.terms.lastUpdated")}</span>
      </div>
    </section>
  );
};

export default TermsHero;
